import { render, staticRenderFns } from "./street-list.vue?vue&type=template&id=57b8bc1d&scoped=true&"
import script from "./street-list.vue?vue&type=script&lang=js&"
export * from "./street-list.vue?vue&type=script&lang=js&"
import style0 from "./street-list.vue?vue&type=style&index=0&id=57b8bc1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8bc1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VDataTable,VSpacer,VTextField})
